import { lazy } from 'react'
import type { RouteObject } from 'react-router'
import { Navigate, Outlet } from 'react-router-dom'
import { wrapWithErrorBoundary } from './wrapWithErrorBoundary'
import { FeatureFlagRoute } from '@/components/FeatureFlagRoute'
import { FeatureNames } from '@/lib/featureFlags'

const CustomerFlowPage = lazy(() => import('@/pages/customerFlow'))
const ReferentialsPage = lazy(() => import('@/pages/customerFlow/referentials'))
const ReferentialDetailPage = lazy(
  () => import('@/pages/customerFlow/referentialDetail')
)

const WrappedCustomerFlowPage = wrapWithErrorBoundary(CustomerFlowPage)
const WrappedReferentialsPage = wrapWithErrorBoundary(ReferentialsPage)
const WrappedReferentialDetailPage = wrapWithErrorBoundary(ReferentialDetailPage)

export const customerFlowNestedRoute: RouteObject = {
  path: 'customer-flow',
  element: <Outlet />,
  children: [
    {
      path: 'flow',
      handle: {
        documentTitle: { namespace: 'nav', key: 'models' },
      },
      element: <WrappedCustomerFlowPage display="flow" />,
    },
    {
      path: 'flow/:id',
      handle: {
        documentTitle: { namespace: 'nav', key: 'details' },
      },
      element: <WrappedCustomerFlowPage display="flow-detail" />,
    },
    {
      path: 'customer',
      handle: {
        documentTitle: { namespace: 'nav', key: 'customers' },
      },
      element: <WrappedCustomerFlowPage display="customer" />,
    },
    {
      path: 'customer/:id',
      handle: {
        documentTitle: { namespace: 'nav', key: 'customers' },
      },
      element: <WrappedCustomerFlowPage display="customer-detail" />,
    },
    {
      path: 'referentials',
      handle: {
        documentTitle: { namespace: 'referentials', key: 'pageTitle' },
      },
      element: (
        <FeatureFlagRoute
          flag={FeatureNames.referentials}
          enabled={WrappedReferentialsPage}
          disabled={() => <Navigate to="/404" replace />}
        />
      ),
    },
    {
      path: 'referentials/:id',
      handle: {
        documentTitle: { namespace: 'referentials', key: 'detailPageTitle' },
      },
      element: (
        <FeatureFlagRoute
          flag={FeatureNames.referentials}
          enabled={WrappedReferentialDetailPage}
          disabled={() => <Navigate to="/404" replace />}
        />
      ),
    },
  ],
}
